interface StarProps {
  size?: number | string;
  color?: string;
}

const Star = ({ size = 15, color = "#0E9F6E" }: StarProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3307_589)">
      <path
        d="M8.29958 0.963135C8.15293 0.661011 7.84303 0.46875 7.5027 0.46875C7.16237 0.46875 6.85524 0.661011 6.70583 0.963135L4.92669 4.59686L0.953385 5.17914C0.621354 5.22858 0.344661 5.45929 0.242284 5.77515C0.139908 6.091 0.222916 6.43982 0.460872 6.67328L3.34401 9.505L2.66335 13.5068C2.60801 13.8364 2.74635 14.1714 3.02028 14.3665C3.2942 14.5615 3.65667 14.5862 3.9555 14.4296L7.50547 12.5482L11.0554 14.4296C11.3543 14.5862 11.7167 14.5642 11.9907 14.3665C12.2646 14.1687 12.4029 13.8364 12.3476 13.5068L11.6642 9.505L14.5473 6.67328C14.7853 6.43982 14.871 6.091 14.7659 5.77515C14.6607 5.45929 14.3868 5.22858 14.0548 5.17914L10.0787 4.59686L8.29958 0.963135Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_3307_589">
        <rect
          width="15.9375"
          height="14.0625"
          fill="white"
          transform="translate(-0.46875 0.46875)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default Star;
